import select2 from 'select2';

export default function initializeWooSelects() {
    initializeSelect2Containers();
}

function initializeSelect2Containers() {
    $('.woocommerce-ordering .orderby').each(function () {
        $(this).select2({
            language: 'pl',
            minimumResultsForSearch: Infinity,
        });
    });

    $('.woocommerce-ordering').on('change', 'select.orderby', function () {
        $(this).closest('form').trigger('submit');
    });
}